export default {
    previousRoute: null
}